import PwaOfflineModeController from "./pwa/offline_mode_controller"

// Field app offline mode selector -- thin wrapper over the shared PWA controller.

export default class extends PwaOfflineModeController {
  static values = {
    ...PwaOfflineModeController.values,
    prefix: { type: String, default: "field" }
  }
}
